<template>
  <div class="home-box">
    <v-progress-linear
      indeterminate
      color="orange"
      v-if="loading"
    ></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card>
      <v-card-title dark>
        <h3 class="ma-2 orange--text">
          Publishing a Club Directory | Month: {{ month }}
        </h3>
        <v-spacer></v-spacer>
        <go-back-btn></go-back-btn>
      </v-card-title>
      <v-divider color="orange"></v-divider>
      <v-form class="pa-5" v-if="publishingClubDirectory && !loading">
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <div class="subtitle-1">
              List Of Office Bearers
            </div>
            <div class="caption">
              {{
                publishingClubDirectory.list_office_bearers == 1 ? "Yes" : "No"
              }}
            </div>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <div class="subtitle-1">
              Details Of Members
            </div>
            <div class="caption">
              {{
                publishingClubDirectory.details_of_members == 1 ? "Yes" : "No"
              }}
            </div>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <div class="subtitle-1">Board Meetings Schedule</div>
            <div class="caption">
              {{
                publishingClubDirectory.board_meetings_schedule == 1
                  ? "Yes"
                  : "No"
              }}
            </div>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <div class="subtitle-1">Regular Meetings Schedules</div>
            <div class="caption">
              {{
                publishingClubDirectory.regular_meetings_schedule == 1
                  ? "Yes"
                  : "No"
              }}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <div class="subtitle-1">Committee Structure</div>
            <div class="caption">
              {{
                publishingClubDirectory.committee_structure == 1 ? "Yes" : "No"
              }}
            </div>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <div class="subtitle-1">Project Proposal</div>
            <div class="caption">
              {{ publishingClubDirectory.project_proposal == 1 ? "Yes" : "No" }}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <div class="subtitle-1">Electronic media (electronic) </div>
            <div class="caption">
              {{
                publishingClubDirectory.electronic == 1 ? "Yes" : "No"
              }}
            </div>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <div class="subtitle-1">Printing media</div>
            <div class="caption">
              {{ publishingClubDirectory.printing == 1 ? "Yes" : "No" }}
            </div>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row v-if="publishingClubDirectory.documents">
          <v-col
            cols="3"
            v-for="item in publishingClubDirectory.documents"
            :key="item.uuid"
          >
            <v-card v-if="item.type === 'pdf'" @click="openImage(item.path)">
              <v-chip class="ma-2" color="pink" label text-color="white">
                <v-icon left>
                  mdi-file-pdf-box
                </v-icon>
                PDF document
              </v-chip>
            </v-card>
            <v-card v-else @click="openImage(item.path)">
              <v-img
                :src="item.path"
                height="150"
                class="grey darken-4"
              ></v-img>
              <v-divider></v-divider>
              <v-card-actions class="text-h6 pa-2">
                Proof document
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
    </v-card>  
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="closeSnackbar"
    />
  </div>
</template>

<script>
import GoBackBtn from "@/components/shared/GoBackBtn";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import { ActivityService } from "../../../services/activity-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "PublishingClubDirectoryView",

  components: { GoBackBtn, Alert, Snackbars },

  data: () => ({
    month: "",
    role: localStorage.getItem("role"),
    loading: false,
    errors: null,
    snackbar: false,
    successMsg: "",
    form: {
      pending_comment: "",
    },
    boardMeeting: [],
    confirm: false,
    publishingClubDirectory: [],
  }),

  mounted() {
    this.month = this.$route.params.month;
    this.getPublishingClubDirectory();
  },

  computed: {
    ...mapGetters({
      defaultExam: "defaultExam",
      defaultSubject: "defaultSubject",
    }),
  },

  methods: {
    getPublishingClubDirectory() {
      if (this.$route.params.aId !== null) {
        this.loading = true;
        ActivityService.getActivityInfo(
          "publishing-club-directories",
          this.$route.params.aId
        )
          .then((response) => {
            this.loading = false;
            if (response.data.data) {
              this.publishingClubDirectory = response.data.data;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.publishingClubDirectory = [];
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
          });
      }
    },
    pending() {},
    submit() {},
    onDismissed() {
      this.errors = null;
    },
    closeSnackbar() {
      this.snackbar = false;
    },
    reset() {
      this.form.name = "";
    },
    openImage(path) {
      window.open(path, "_blank");
    },
  },
};
</script>
